module.exports = "md-list-item.listing.list-margin.total {\n    background: #000 !important;\n}\n#chckoutbtn{\n    margin-top: 12px;\n    margin-right: 10px;\n}\n.headng {\n        margin-left: 91%;\n    }\n.headng2 {\n        margin-right: 5%;\n        margin-top: 1.3%;\n    }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cart/view-cart/view-cart.component.css
// module id = ./src/app/cart/view-cart/view-cart.component.css
// module chunks = main